import { useTranslation } from '@frontend/i18n';
import { useTourGuideEventShallowStore, useTourGuideShallowStore } from '../../../hooks';
import { GuideNameEnum } from '../../../types';
import { StepContainer } from '../../step-container';
import { StepIndexNames } from '../use-advance-tour-guide';

export const DownloadSoftwareTooltip = () => {
  const { t } = useTranslation('tour-guide');
  const { advanceGuide } = useTourGuideShallowStore('advanceGuide');
  const { setStepActionEvent } = useTourGuideEventShallowStore('setStepActionEvent');

  const onNextClick = () => {
    setStepActionEvent(t(`Next button clicked`));
    advanceGuide(GuideNameEnum.PortalWelcomeExperienceSetup);
  };

  const onBackClick = () => {
    setStepActionEvent(t('Back button clicked'));
    advanceGuide(GuideNameEnum.PortalWelcomeExperienceSetup, StepIndexNames.TrainingToolTip);
  };

  return (
    <StepContainer>
      <StepContainer.Text>
        {t(
          `Access Weave's essential tools like phones, messaging, scheduling, and payments from anywhere with the Weave App. Start your download now using the provided instructions.`
        )}
      </StepContainer.Text>
      <StepContainer.Footer
        primaryButtonText={t(`Next`)}
        onPrimaryButtonClick={onNextClick}
        secondaryButtonText={t(`Back`)}
        onSecondaryButtonClick={onBackClick}
      />
    </StepContainer>
  );
};
